import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-015c700f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "listItem" }
const _hoisted_2 = { class: "listItemHeader" }
const _hoisted_3 = { class: "vendorName" }
const _hoisted_4 = { class: "toggleContainer" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex-grow":"1"} }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vendorPurposeOrFeatureLabel" }, "Our partners may:", -1))
const _hoisted_8 = { class: "vendorPurposeOrFeatureID" }
const _hoisted_9 = { class: "vendorPurposeOrFeatureText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToggleButton = _resolveComponent("ToggleButton")!
  const _component_ChevronIcon = _resolveComponent("ChevronIcon")!
  const _component_Vue3SlideUpDown = _resolveComponent("Vue3SlideUpDown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.feature.name), 1),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createVNode(_component_ToggleButton, {
          onChange: _ctx.changeConsent,
          sync: true,
          value: _ctx.consent,
          style: {"margin-left":"8px"},
          width: 64,
          height: 30,
          speed: 200,
          color: {checked: '#34b76f', unchecked: '#94a7d1'}
        }, null, 8, ["onChange", "value"]),
        _createVNode(_component_ChevronIcon, {
          onClick: _ctx.expandCollapseClick,
          class: _normalizeClass(_ctx.collapseClass)
        }, null, 8, ["onClick", "class"])
      ])
    ]),
    _createVNode(_component_Vue3SlideUpDown, {
      modelValue: _ctx.expanded,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.expanded) = $event)),
      duration: 200,
      class: "listItemDetail"
    }, {
      default: _withCtx(() => [
        _hoisted_7,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formattedDescriptions, (s, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: "vendorPurposeOrFeatureDesc"
          }, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(i+1), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(s), 1)
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}